export default __webpack_public_path__ + "static/media/profile.98945f4a.png";